export const KNEE_PAIN_STATUSES = [
  {
    id: 1,
    text: "全く痛くない",
  },
  {
    id: 2,
    text: "あまり痛くない",
  },
  {
    id: 3,
    text: "やや痛い",
  },
  {
    id: 4,
    text: "かなり痛い",
  },
  {
    id: 5,
    text: "とても痛い",
  },
];
